function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var utils = require('./utils');

var FORMATS = require('./formats'); // Use these to help sort formats, higher index is better.


var audioEncodingRanks = ['mp4a', 'mp3', 'vorbis', 'aac', 'opus', 'flac'];
var videoEncodingRanks = ['mp4v', 'avc1', 'Sorenson H.283', 'MPEG-4 Visual', 'VP8', 'VP9', 'H.264'];

var getVideoBitrate = function getVideoBitrate(format) {
  return format.bitrate || 0;
};

var getVideoEncodingRank = function getVideoEncodingRank(format) {
  return videoEncodingRanks.findIndex(function (enc) {
    return format.codecs && format.codecs.includes(enc);
  });
};

var getAudioBitrate = function getAudioBitrate(format) {
  return format.audioBitrate || 0;
};

var getAudioEncodingRank = function getAudioEncodingRank(format) {
  return audioEncodingRanks.findIndex(function (enc) {
    return format.codecs && format.codecs.includes(enc);
  });
};
/**
 * Sort formats by a list of functions.
 *
 * @param {Object} a
 * @param {Object} b
 * @param {Array.<Function>} sortBy
 * @returns {number}
 */


var sortFormatsBy = function sortFormatsBy(a, b, sortBy) {
  var res = 0;

  var _iterator = _createForOfIteratorHelper(sortBy),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var fn = _step.value;
      res = fn(b) - fn(a);

      if (res !== 0) {
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
};

var sortFormatsByVideo = function sortFormatsByVideo(a, b) {
  return sortFormatsBy(a, b, [function (format) {
    return parseInt(format.qualityLabel);
  }, getVideoBitrate, getVideoEncodingRank]);
};

var sortFormatsByAudio = function sortFormatsByAudio(a, b) {
  return sortFormatsBy(a, b, [getAudioBitrate, getAudioEncodingRank]);
};
/**
 * Sort formats from highest quality to lowest.
 *
 * @param {Object} a
 * @param {Object} b
 * @returns {number}
 */


exports.sortFormats = function (a, b) {
  return sortFormatsBy(a, b, [// Formats with both video and audio are ranked highest.
  function (format) {
    return +!!format.isHLS;
  }, function (format) {
    return +!!format.isDashMPD;
  }, function (format) {
    return +(format.contentLength > 0);
  }, function (format) {
    return +(format.hasVideo && format.hasAudio);
  }, function (format) {
    return +format.hasVideo;
  }, function (format) {
    return parseInt(format.qualityLabel) || 0;
  }, getVideoBitrate, getAudioBitrate, getVideoEncodingRank, getAudioEncodingRank]);
};
/**
 * Choose a format depending on the given options.
 *
 * @param {Array.<Object>} formats
 * @param {Object} options
 * @returns {Object}
 * @throws {Error} when no format matches the filter/format rules
 */


exports.chooseFormat = function (formats, options) {
  if (typeof options.format === 'object') {
    if (!options.format.url) {
      throw Error('Invalid format given, did you use `ytdl.getInfo()`?');
    }

    return options.format;
  }

  if (options.filter) {
    formats = exports.filterFormats(formats, options.filter);
  } // We currently only support HLS-Formats for livestreams
  // So we (now) remove all non-HLS streams


  if (formats.some(function (fmt) {
    return fmt.isHLS;
  })) {
    formats = formats.filter(function (fmt) {
      return fmt.isHLS || !fmt.isLive;
    });
  }

  var format;
  var quality = options.quality || 'highest';

  switch (quality) {
    case 'highest':
      format = formats[0];
      break;

    case 'lowest':
      format = formats[formats.length - 1];
      break;

    case 'highestaudio':
      {
        formats = exports.filterFormats(formats, 'audio');
        formats.sort(sortFormatsByAudio); // Filter for only the best audio format

        var bestAudioFormat = formats[0];
        formats = formats.filter(function (f) {
          return sortFormatsByAudio(bestAudioFormat, f) === 0;
        }); // Check for the worst video quality for the best audio quality and pick according
        // This does not loose default sorting of video encoding and bitrate

        var worstVideoQuality = formats.map(function (f) {
          return parseInt(f.qualityLabel) || 0;
        }).sort(function (a, b) {
          return a - b;
        })[0];
        format = formats.find(function (f) {
          return (parseInt(f.qualityLabel) || 0) === worstVideoQuality;
        });
        break;
      }

    case 'lowestaudio':
      formats = exports.filterFormats(formats, 'audio');
      formats.sort(sortFormatsByAudio);
      format = formats[formats.length - 1];
      break;

    case 'highestvideo':
      {
        formats = exports.filterFormats(formats, 'video');
        formats.sort(sortFormatsByVideo); // Filter for only the best video format

        var bestVideoFormat = formats[0];
        formats = formats.filter(function (f) {
          return sortFormatsByVideo(bestVideoFormat, f) === 0;
        }); // Check for the worst audio quality for the best video quality and pick according
        // This does not loose default sorting of audio encoding and bitrate

        var worstAudioQuality = formats.map(function (f) {
          return f.audioBitrate || 0;
        }).sort(function (a, b) {
          return a - b;
        })[0];
        format = formats.find(function (f) {
          return (f.audioBitrate || 0) === worstAudioQuality;
        });
        break;
      }

    case 'lowestvideo':
      formats = exports.filterFormats(formats, 'video');
      formats.sort(sortFormatsByVideo);
      format = formats[formats.length - 1];
      break;

    default:
      format = getFormatByQuality(quality, formats);
      break;
  }

  if (!format) {
    throw Error("No such format found: ".concat(quality));
  }

  return format;
};
/**
 * Gets a format based on quality or array of quality's
 *
 * @param {string|[string]} quality
 * @param {[Object]} formats
 * @returns {Object}
 */


var getFormatByQuality = function getFormatByQuality(quality, formats) {
  var getFormat = function getFormat(itag) {
    return formats.find(function (format) {
      return "".concat(format.itag) === "".concat(itag);
    });
  };

  if (Array.isArray(quality)) {
    return getFormat(quality.find(function (q) {
      return getFormat(q);
    }));
  } else {
    return getFormat(quality);
  }
};
/**
 * @param {Array.<Object>} formats
 * @param {Function} filter
 * @returns {Array.<Object>}
 */


exports.filterFormats = function (formats, filter) {
  var fn;

  switch (filter) {
    case 'videoandaudio':
    case 'audioandvideo':
      fn = function fn(format) {
        return format.hasVideo && format.hasAudio;
      };

      break;

    case 'video':
      fn = function fn(format) {
        return format.hasVideo;
      };

      break;

    case 'videoonly':
      fn = function fn(format) {
        return format.hasVideo && !format.hasAudio;
      };

      break;

    case 'audio':
      fn = function fn(format) {
        return format.hasAudio;
      };

      break;

    case 'audioonly':
      fn = function fn(format) {
        return !format.hasVideo && format.hasAudio;
      };

      break;

    default:
      if (typeof filter === 'function') {
        fn = filter;
      } else {
        throw TypeError("Given filter (".concat(filter, ") is not supported"));
      }

  }

  return formats.filter(function (format) {
    return !!format.url && fn(format);
  });
};
/**
 * @param {Object} format
 * @returns {Object}
 */


exports.addFormatMeta = function (format) {
  format = Object.assign({}, FORMATS[format.itag], format);
  format.hasVideo = !!format.qualityLabel;
  format.hasAudio = !!format.audioBitrate;
  format.container = format.mimeType ? format.mimeType.split(';')[0].split('/')[1] : null;
  format.codecs = format.mimeType ? utils.between(format.mimeType, 'codecs="', '"') : null;
  format.videoCodec = format.hasVideo && format.codecs ? format.codecs.split(', ')[0] : null;
  format.audioCodec = format.hasAudio && format.codecs ? format.codecs.split(', ').slice(-1)[0] : null;
  format.isLive = /\bsource[/=]yt_live_broadcast\b/.test(format.url);
  format.isHLS = /\/manifest\/hls_(variant|playlist)\//.test(format.url);
  format.isDashMPD = /\/manifest\/dash\//.test(format.url);
  return format;
};